export const selectPatientSplitRestricted = (state) => state.records.patientSplitRestricted === true
  || (!state.records.fileToken && state.records.selectedRecordDetails?.patient_split_restricted === true);

export const selectionHasRestrictedPatientSplit = (records = []) => records.some(
  (record) => record?.patient_split_restricted === true,
);
